import React, { useEffect, useState } from 'react';
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { isColorLight, useWindowSize } from '../../../utils/FunctionsGlobals';
import { paginaInternaAtelier } from '../../pieces/atelier/atelier';
import CardManager from '../../cards/manager/CardManager';
import CardManager1 from '../../cards/manager/CardManager1';
import styles from './ManagerCard.module.css';

function shuffleArray(array: any[]) {
    const shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
    }
    return shuffledArray;
  }
// interfaces
interface IApartamentCard {
    slides: Array<any>;
    title: string;
    site: any;
}
const ManagerCard: React.FC<IApartamentCard> = ({ slides, title, site }) => {
    const cor_texto = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13; 
    const size = useWindowSize();
    const [shuffledSlides, setShuffledSlides] = useState<Array<any>>([]);
      const stylo: React.CSSProperties = {
        '--swiper-navigation-color': isColorLight(site?.cor5) ? site?.cor2 : cor_texto,
        '--swiper-pagination-color': isColorLight(site?.cor5) ? site?.cor2 : cor_texto,
        '--swiper-pagination-bullet-inactive-color': isColorLight(site?.cor5) ? site?.cor2 : cor_texto,
        '--swiper-pagination-bullet-inactive-opacity': '0.5',
        '--swiper-pagination-bullet-size': '15px',
        'height': site?.modelo_depoimento == 3 ? '640px' : '500px'
      } as React.CSSProperties;

    useEffect(() => {
      // Embaralha o array de slides quando o componente é montado
      if(site?.id != "1893"){
        setShuffledSlides(shuffleArray(slides));
      } else {
        setShuffledSlides(slides);
      }
    }, [slides, site]);

    const renderIndex = () => {
        if(!size.width){
            return 3;
        }
        if (size?.width < 710 || slides.length == 1) {
            return 1;
        }
        if (size?.width < 1050 || slides.length == 2) {
            return 2;
        }
    if (size?.width < 1380 || slides.length == 3) {
            return 3;
        }
        if (size?.width < 1700 || slides.length == 4) {
            return 4;
        }
        if (size?.width >= 1700 || slides.length == 5){
            return 5
        }
        return 3;
    };

    return (
        <div className={styles.container}>
          {site?.id != 2269 ?
            <h3 className={styles.label} style={{color: cor_texto}}><b>{title}</b></h3>
          : null}
          <Swiper
            modules={[Pagination]}
            style={stylo}
            className={styles.cards}
            // Atelier (topo 12): a home para em 1360 px de largura, por mais larga que seja a janela — o
            // corte acima é pela largura da JANELA e, em tela grande, espremeria 5 cards onde cabem 4.
            slidesPerView={paginaInternaAtelier(site) ? Math.min(renderIndex() || 3, 4) : renderIndex() || 3}
            slidesPerGroup={1}
            pagination={{ clickable: true, dynamicBullets: true }} // ATIVAR
          >
            {shuffledSlides?.map((slide) => {
              return (
                <SwiperSlide key={slide?.id} className={styles.card}>
                  {site?.modelo_equipe == 2 ?
                  <CardManager1 slide={slide} key={slide?.id} site={site} />
                  :
                  <CardManager slide={slide} key={slide?.id} site={site} />}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      );
    };

export default ManagerCard;
